import {Entry} from './Entry';

export class Expense extends Entry {
    constructor() {
        super(...arguments);

        this.type = 'expense';
    }
}
